import React from "react";

import './VideoTag.scss'

const VideoTag = ({ tagName }) => {
  if (!tagName) {
    return null;
  }
  const tagPrefix = '#';
  return (
    <span className='video-tag'>
      {tagPrefix}{tagName}
    </span>
  );
};

export default VideoTag;
